import React from "react";
import Icons from "./Icons";
import SectionContent from "./SectionContent";

const SectionEditor = ({
  section,
  location,
  index,
  totalSections,
  updateSection,
  removeSection,
  moveSection,
  expandedSections,
  toggleSectionExpansion,
  addSectionItem,
  updateSectionItem,
  removeSectionItem,
}) => {
  const isExpanded = expandedSections[section.id] !== false;

  return (
    <div className={`section-editor ${isExpanded ? "expanded" : "collapsed"}`}>
      <div className="section-header">
        <div className="section-header-left">
          <button
            className="drag-handle"
            title="Drag to reorder"
            aria-label="Drag to reorder section"
          >
            <Icons.Grip className="w-5 h-5" />
          </button>

          <div className="section-title-group">
            {section.icon && (
              <span className="section-icon">{section.icon}</span>
            )}
            <input
              type="text"
              value={section.title}
              onChange={(e) =>
                updateSection(location, section.id, { title: e.target.value })
              }
              className="section-title-input"
              placeholder="Section Title"
            />
          </div>
        </div>

        <div className="section-controls">
          {/* Move Up Button */}
          {index > 0 && (
            <button
              onClick={() => moveSection(location, index, "up")}
              className="control-button"
              title="Move section up"
              aria-label="Move section up"
            >
              <Icons.ChevronUp className="w-4 h-4" />
            </button>
          )}

          {/* Move Down Button */}
          {index < totalSections - 1 && (
            <button
              onClick={() => moveSection(location, index, "down")}
              className="control-button"
              title="Move section down"
              aria-label="Move section down"
            >
              <Icons.ChevronDown className="w-4 h-4" />
            </button>
          )}

          {/* Expand/Collapse Button */}
          <button
            onClick={() => toggleSectionExpansion(section.id)}
            className="control-button"
            title={isExpanded ? "Collapse section" : "Expand section"}
            aria-label={isExpanded ? "Collapse section" : "Expand section"}
            aria-expanded={isExpanded}
          >
            {isExpanded ? (
              <Icons.ChevronUp className="w-4 h-4" />
            ) : (
              <Icons.ChevronDown className="w-4 h-4" />
            )}
          </button>

          {/* Delete Button */}
          <button
            onClick={() => {
              if (
                window.confirm(
                  `Are you sure you want to remove the "${section.title}" section?`
                )
              ) {
                removeSection(location, section.id);
              }
            }}
            className="control-button delete"
            title="Remove section"
            aria-label="Remove section"
          >
            <Icons.Trash className="w-4 h-4" />
          </button>
        </div>
      </div>

      {isExpanded && (
        <div className="section-body">
          <SectionContent
            section={section}
            location={location}
            updateSection={updateSection}
            addSectionItem={addSectionItem}
            updateSectionItem={updateSectionItem}
            removeSectionItem={removeSectionItem}
          />
        </div>
      )}
    </div>
  );
};

export default SectionEditor;
